/***
 * 公用常量配置
 */
// 奖品类型
const prizeTypeList = [
  { value: 1, label: '优惠券' },
  { value: 2, label: '京豆' },
  { value: 3, label: '实物' },
  { value: 4, label: '店铺积分' },
  { value: 5, label: '京东E卡' },
  { value: 6, label: '爱奇艺会员' },
  { value: 7, label: '京东PLUS会员' },
	{ value: 8, label: '现金红包' },
	{ value: 9, label: '谢谢参与' },
  { value: 10, label: '礼品卡' },
  { value: 12, label: '专享价' },
  { value: 13, label: '令牌' },
  { value: 14, label: '实物（随单发）' },
];
export default {
  install(Vue) {
    //会员等级
    Vue.prototype.memberUser_all = [
      {
        value: "0",
        label: '店铺会员'
      },
      {
        value: "1",
        label: '普通会员'
      },
      {
        value: "2",
        label: '高级会员'
      },
      {
        value: "3",
        label: 'VIP会员'
      },
      {
        value: "4",
        label: '至尊VIP会员'
      }
    ];
    //性别
    Vue.prototype.sex_all = [
      {
        value: '0',
        label: '未知'
      },
      {
        value: '1',
        label: '男'
      },
      {
        value: '2',
        label: '女'
      },
    ];
    //全局引用，并且或者
    Vue.prototype.sureOr_all = [
      {
          id: 0,
          label: '并且'
      },
      {
          id: 1,
          label: '或者'
       }
     ];
    //职业
    Vue.prototype.worker_all = [
      {
        value: '1',
        label: '学生'
      },
      {
        value: '2',
        label: '白领'
      },
      {
        value: '3',
        label: '公务员'
      }
      ,
      {
        value: '4',
        label: 'IT'
      }
      ,
      {
        value: '5',
        label: '金融族'
      },
      {
        value: '6',
        label: '居家族'
      },
      {
        value: '7',
        label: '医护人员'
      },
      {
        value: '8',
        label: '其他'
      }
    ];

    // type: 1：传值 0：传input实例
    // e: 值或者input实例
    // decimal: 1表示允许小数点 0表示整数, 
    // min：允许传入最小值，小于这个值时返回""
    Vue.prototype.getNumberData = function(type, e, decimal = 0, min = 1, max = -1) {
      let str = ""
      if(type) {
        str = String(e)
      } else {
        str = String(e.target.value)
      }
      
      let num = decimal ? str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') : str.replace(/[^\d]/g, '')
      if (num < min) {
        num = "";
      }
      if (max != -1 && max < num) {
        num = max;
      }
      return num
    }
    // 添加奖品类型判断方法
    Vue.prototype.getPrizeTypeName = function(value) {
      const obj = prizeTypeList.find(item => item.value == value);
      if(obj) {
        return obj.label;
      } else {
        return ''
      }
    };
    // 实物随单发：新增字段
    Vue.prototype.getPhysicalShipped = function(obj,prizeType,data) {
      if (!data.isGoodManage) {
        obj.skuId = data.skuId;
        delete obj.isGoodManage;
      } else {
        obj.isGoodManage = data.isGoodManage;
      }
      obj.pointActivityPrizeRemark = data.pointActivityPrizeRemark;
      return obj;
    }
    Vue.prototype.useValidateMoreActSet = function(that) {
      // 更多活动设置
      if(that.customerPaperwork&&that.customerPaperwork.moreActSet) {
        const moreActSet = that.customerPaperwork.moreActSet;
        if(moreActSet.isShowFloatWindow==1) {
          if(!moreActSet.floatWindowImg) {
            that.$message.warning("请上传浮窗图片");
            return;
          }
          // if(moreActSet.goShopSetting==1&&!moreActSet.goShopAppId) {
          //   that.$message.warning("请完善跳转链接");
          //   return;
          // }
          if (moreActSet.goShopSetting == 2) {
            // if (!moreActSet.goShopUrl) {
            //   that.$message.warning("请完善跳转链接");
            //   return;
            // } else 
            if (moreActSet.goShopUrl&&
              !moreActSet.goShopUrl.startsWith("https://") ||
              !moreActSet.goShopUrl.includes("jd.com")
            ) {
              that.$message.warning(
                "浮窗图片跳转链接输入的内容非链接或为接口无法支持的链接，请重新设置"
              );
              return;
            }
          }
        }
        if(moreActSet.isShowBanner==1) {
          if(!moreActSet.bannerList.length) {
            that.$message.warning("请添加活动banner");
            return;
          }
        }
      }
      return true;
    }
  }
}